import { render, staticRenderFns } from "./Kareem.vue?vue&type=template&id=068e087e&"
import script from "./Kareem.vue?vue&type=script&lang=js&"
export * from "./Kareem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports